// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AUI9","colBig":"styles_colBig__1jzFs","colSmall":"styles_colSmall__3FYKR"};